import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
    password: Yup.string().required('La contraseña es obligatoria').min(6, "La contraseña tiene que tener al menos 6 caracteres"),
    repassword: Yup.string().required('Este campo es obligatorio').oneOf([Yup.ref('password'), null], "La contraseña no coincide"),
})

export default validationSchema